<template>

  <head>

    <meta charset="utf-8" />
    <title>Commercials | Partially paid invoices</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body @contextmenu.prevent data-sidebar="dark">


  <div id="layout-wrapper">
    <NavigationBar/>
    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Transaction Correction</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="#">Action Center</a></li>
                    <li class="breadcrumb-item active">Transaction Correction</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                  <div class="flex-grow-1">
                    <div class="search-box mb-0 me-3">
                      <div class="position-relative">
                        <input
                            v-model="keyword"
                            type="text"
                            class="form-control bg-light border-light rounded"
                            placeholder="Search For Wrong payment"
                            @keyup.enter="getTransactions()"
                            :disabled="isLoading"
                            spellcheck="false"
                            data-ms-editor="true">
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex">
                    <button
                        @click="getTransactions()"
                        class="btn btn-primary waves-effect waves-light me-2"
                        :disabled="isLoading">
                      <i class="bx bx-search-alt me-1"></i> Search
                    </button>
                    <button
                        @click="resetSearch()"
                        class="btn btn-light waves-effect"
                        :disabled="isLoading">
                      <i class="bx bx-reset me-1"></i> Reset
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading state -->
                  <div v-if="isLoading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-3 text-muted">Loading transactions...</p>
                  </div>

                  <!-- Empty state -->
                  <div v-else-if="Transactions.length === 0" class="text-center py-5">
                    <i class="bx bx-info-circle font-size-48 text-muted mb-3 d-block"></i>
                    <h5>No Transactions Found</h5>
                    <p class="text-muted">Try adjusting your search criteria or check back later.</p>
                  </div>

                  <!-- Data table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover contacts-table table-striped table-nowrap" id="datatable-buttons1">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th>Receipt No.</th>
                        <th>Bill No.</th>
                        <th>Receipted By</th>
                        <th scope="col">Date Receipted</th>
                        <th scope="col">Method</th>
                        <th class="text-right">Amount Receipted</th>
                        <th>Correction Details</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in Transactions" :key="index" :class="{'highlight-row': isHighlighted(item)}">
                        <td class="col-spa">{{item.transaction_code || '-'}}</td>
                        <td class="col-spa">{{item.account_ref || '-'}}</td>
                        <td>{{item.names || '-'}}</td>
                        <td class="text-capitalize text-nowrap">{{formatDate(item.date)}}</td>
                        <td>
                          <span :class="getPaymentMethodClass(item.payment_type)">{{item.payment_type || '-'}}</span>
                          {{item.account_from || ''}}
                        </td>
                        <td class="text-nowrap text-right">
                          <span class="fw-semibold">KES {{formatAmount(item.amount)}}</span>
                        </td>
                        <td>
                          <span class="fw-semibold">{{item.correctionDetails || '-'}}</span>
                        </td>
                        <td class="text-right">
                          <div class="d-flex">
                            <button
                                @click="ApprovedTransactionCorrection(item)"
                                type="button"
                                class="btn btn-success btn-sm waves-effect waves-light text-nowrap me-3"
                                :disabled="!canApprove(item) || isProcessing"
                            >
                                <span v-if="isProcessingItem(item)">
                                  <span class="spinner-border spinner-border-sm me-1" role="status"></span>Processing...
                                </span>
                              <span v-else>Approve</span>
                            </button>
                            <button
                                @click="viewDetails(item)"
                                type="button"
                                class="btn btn-info btn-sm waves-effect waves-light text-nowrap">
                              <i class="bx bx-detail me-1"></i> Details
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Pagination -->
                  <div v-if="Transactions.length > 0" class="d-flex justify-content-between align-items-center mt-4">
                    <div>
                      <span class="text-muted">Showing {{Transactions.length}} transactions</span>
                    </div>
                    <nav aria-label="Page navigation">
                      <ul class="pagination">
                        <!-- Pagination would go here if implemented -->
                        <li class="page-item disabled"><a class="page-link" href="#">1</a></li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>
          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- receipting modal -->
      <div class="modal fade receipting-modal pb-5" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mb-5">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Transaction Correction</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div class="">
                    <div class="alert alert-warning" role="alert">
                      <h4 class="alert-heading">Please Note!</h4>
                      <p>The bill number must exist and receipted amount should equal the invoiced amount</p>
                      <hr>

                      <div class="">
                        <label for="formrow-firstname-input" class="form-label">Bill Number</label>
                        <div class="input-group mb-3">
                          <input
                              v-model="search"
                              class="form-control"
                              type="text"
                              placeholder="Bill Number"
                              :disabled="isSearchingBill"
                              aria-label="Bill Number"
                              spellcheck="false"
                              data-ms-editor="true">
                          <button
                              @click="getBill()"
                              class="btn btn-primary"
                              type="button"
                              :disabled="!search || isSearchingBill">
                            <span v-if="isSearchingBill">
                              <span class="spinner-border spinner-border-sm" role="status"></span>
                            </span>
                            <span v-else><i class="bx bx-search"></i></span>
                          </button>
                        </div>

                        <p v-if="message" class="text-info"> {{message}}</p>

                        <!-- Bill information -->
                        <div v-if="detailAmount !== '--'" class="card border p-3 mt-3">
                          <div class="d-flex justify-content-between mb-2">
                            <span>Bill Amount:</span>
                            <span class="fw-bold text-black">KES {{formatAmount(detailAmount)}}</span>
                          </div>
                          <div class="d-flex justify-content-between mb-2">
                            <span>Paid Amount:</span>
                            <span class="fw-bold text-black">KES {{formatAmount(receiptAmount)}}</span>
                          </div>
                          <div class="d-flex justify-content-between mb-2">
                            <span>Balance Amount:</span>
                            <span class="fw-bold text-black">KES {{formatAmount(billBalance)}}</span>
                          </div>

                          <div v-if="customerPhoneNumber || feeDescription" class="mt-3 pt-2 border-top">
                            <div v-if="customerPhoneNumber" class="mb-1">
                              <strong>Phone:</strong> {{customerPhoneNumber}}
                            </div>
                            <div v-if="feeDescription" class="mb-1">
                              <strong>Description:</strong> {{feeDescription}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button
                  @click="submitPaymentCorrection"
                  class="btn btn-primary"
                  :disabled="disabledStatus || isProcessing">
                <span v-if="isProcessing">
                  <span class="spinner-border spinner-border-sm me-1" role="status"></span>Processing...
                </span>
                <span v-else>Complete Correction</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- end of receipting modal -->

      <!-- Transaction details modal -->
      <div class="modal fade transaction-details-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Transaction Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" v-if="selectedTransaction">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <h6 class="text-muted mb-2">Receipt Information</h6>
                    <div class="card border p-3">
                      <div class="d-flex justify-content-between mb-2">
                        <span>Receipt No:</span>
                        <span class="fw-bold">{{selectedTransaction.transaction_code || '-'}}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-2">
                        <span>Bill No:</span>
                        <span class="fw-bold">{{selectedTransaction.account_ref || '-'}}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-2">
                        <span>Amount:</span>
                        <span class="fw-bold">KES {{formatAmount(selectedTransaction.amount)}}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-2">
                        <span>Date:</span>
                        <span class="fw-bold">{{formatDate(selectedTransaction.date)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <h6 class="text-muted mb-2">Payment Details</h6>
                    <div class="card border p-3">
                      <div class="d-flex justify-content-between mb-2">
                        <span>Method:</span>
                        <span class="fw-bold">{{selectedTransaction.payment_type || '-'}}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-2">
                        <span>Account:</span>
                        <span class="fw-bold">{{selectedTransaction.account_from || '-'}}</span>
                      </div>
                      <div class="d-flex justify-content-between mb-2">
                        <span>Receipted By:</span>
                        <span class="fw-bold">{{selectedTransaction.names || '-'}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-3">
                <h6 class="text-muted mb-2">Correction Information</h6>
                <div class="alert alert-info">
                  <p class="mb-0">{{selectedTransaction.correctionDetails || 'No correction details available'}}</p>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button
                  @click="ApprovedTransactionCorrection(selectedTransaction)"
                  type="button"
                  class="btn btn-success"
                  :disabled="!canApprove(selectedTransaction) || isProcessing">
                <span v-if="isProcessing">
                  <span class="spinner-border spinner-border-sm me-1" role="status"></span>Processing...
                </span>
                <span v-else>Approve Correction</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end transaction details modal -->

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                The App
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>

  </body>

</template>


<script>
/* eslint-disable */
import { authUrl, biller, execute, getRight } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import Approved from "@/components/sbp/Approved.vue";

export default {
  name: "TransactionCorrection",
  computed: {
    Approved() {
      return Approved;
    }
  },
  components: { NavigationBar },
  data() {
    return {
      isLoading: false,
      isProcessing: false,
      processingItemId: null,
      isSearchingBill: false,
      disabledStatus: true,
      message: '',
      keyword: '',
      search: '',
      transaction_code: '',
      selectedTransaction: null,
      highlightedTransactionId: null,
      Transactions: [],
      transaction: {
        amount: null,
        payment_type: null,
        account_from: null,
        transaction_code: null,
        account_ref: null,
        date: null,
        names: null,
        verified: null,
        verifiedBy: null,
        code: null,
        correctionDetails: null
      },
      billDetails: {
        id: "",
        billNo: "",
        incomeTypeID: "",
        incomeTypeDescription: "",
        costCenterNo: "",
        accountNo: "",
        description: "",
        feeID: "",
        detailAmount: "",
        receiptAmount: "",
        billBalance: "",
        wardID: "",
        subCountyID: "",
        status: "",
        dateCreated: ""
      },
      billInfo: [],
      detailAmount: '--',
      receiptAmount: '--',
      billBalance: '--',
      customerPhoneNumber: null,
      feeDescription: null,
      toastMessages: []
    }
  },
  mounted() {
    this.getTransactions();
    this.menuAccess();

    // Set up watchers
    this.$watch('keyword', function(newVal, oldVal) {
      if (oldVal !== '' && newVal === '') {
        this.getTransactions();
      }
    });
  },
  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Fagged Transactions");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .catch((error) => {
            this.showToast("Error accessing menu: " + error.message, "error");
          });
    },

    selectedTransactionCode(transaction_code) {
      this.transaction_code = transaction_code;
    },

    // New method to view transaction details
    viewDetails(transaction) {
      this.selectedTransaction = transaction;
      // Use Bootstrap modal show method
      const modal = new bootstrap.Modal(document.querySelector('.transaction-details-modal'));
      modal.show();
    },

    resetSearch() {
      this.keyword = '';
      this.getTransactions();
    },

    getBill() {
      if (!this.search) return;

      this.isSearchingBill = true;
      this.disabledStatus = true;
      this.message = 'Searching..';
      this.detailAmount = '--';
      this.receiptAmount = '--';
      this.billBalance = '--';
      this.customerPhoneNumber = null;
      this.feeDescription = null;

      const data = new FormData();
      data.append("function", "getBill");
      data.append("billNo", this.search);

      execute(data, biller)
          .then((res) => {
            this.message = '';
            if (res.data.success) {
              this.billDetails = res.data.data.billDetails;
              this.detailAmount = this.billDetails.detailAmount;
              this.receiptAmount = this.billDetails.receiptAmount;
              this.billBalance = this.billDetails.billBalance;
              this.customerPhoneNumber = this.billDetails.customerPhoneNumber;
              this.feeDescription = this.billDetails.feeDescription;
              this.disabledStatus = false;
              this.showToast("Bill details retrieved successfully", "success");
            } else {
              this.disabledStatus = true;
              this.message = res.data.message || 'Bill not found';
              this.showToast("Bill not found", "warning");
            }
          })
          .catch((e) => {
            this.message = e.message;
            this.showToast("Error retrieving bill: " + e.message, "error");
          })
          .finally(() => {
            this.isSearchingBill = false;
          });
    },

    getTransactions() {
      this.isLoading = true;

      const data = new FormData();
      data.append("function", "getPaymentCorrectionNeeded");
      data.append("keyword", this.keyword);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.Transactions = res.data.data.Transactions || [];
              if (this.Transactions.length === 0) {
                this.showToast("No transactions found", "info");
              }
            } else {
              this.Transactions = [];
              this.showToast(res.data.data.message || "Error retrieving transactions", "error");
            }
          })
          .catch((e) => {
            this.Transactions = [];
            this.showToast("Error retrieving transactions: " + e.message, "error");
          })
          .finally(() => {
            this.isLoading = false;
          });
    },

    submitPaymentCorrection() {
      this.isProcessing = true;

      const data = new FormData();
      data.append("function", "submitPaymentCorrection");
      data.append("billNo", this.billDetails.billNo);
      data.append("transaction_code", this.transaction.transaction_code);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("sessionPhoneNumber", sessionStorage.getItem("sessionPhoneNumber"));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.message = res.data.message;
              this.getTransactions();
              this.showToast(res.data.message, "success");
              // Close the modal
              const modalElement = document.querySelector('.receipting-modal');
              const modal = bootstrap.Modal.getInstance(modalElement);
              if (modal) modal.hide();
            } else {
              this.message = res.data.message;
              this.showToast(res.data.message, "error");
            }
          })
          .catch((e) => {
            this.message = e.message;
            this.showToast("Error submitting correction: " + e.message, "error");
          })
          .finally(() => {
            this.isProcessing = false;
            this.processingItemId = null;
          });
    },

    ApprovedTransactionCorrection(item) {
      this.transaction = item;
      this.processingItemId = item.transaction_code;
      this.highlightedTransactionId = item.transaction_code;

      // Check permission
      if (!getRight('APPROVE PAYMENT CORRECTION')) {
        this.showToast("Action Denied. You don't have the rights to approve Payment Correction", "error");
        this.processingItemId = null;
        return;
      }

      // Check if correction details exist
      if (!item.correctionDetails || item.correctionDetails.trim() === '') {
        this.showToast('The transaction has no correction to be made. Kindly request a correction.', "warning");
        this.processingItemId = null;
        return;
      }

      // Confirm with the user
      const confirmed = window.confirm("Are you sure you want to approve? " + item.correctionDetails);
      if (confirmed) {
        try {
          // Extract the bill number from correction details
          const correctionParts = item.correctionDetails.split('New Ref: ');
          if (correctionParts.length < 2) {
            throw new Error('Invalid correction format. Unable to extract new reference number.');
          }

          this.billDetails.billNo = correctionParts[1].trim();
          this.submitPaymentCorrection();
        } catch (error) {
          this.showToast("Error processing correction: " + error.message, "error");
          this.processingItemId = null;
        }
      } else {
        // Logic if canceled
        console.log('Approval canceled.');
        this.processingItemId = null;
      }
    },

    // Helper methods
    formatDate(dateString) {
      if (!dateString) return '-';

      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        return dateString;
      }
    },

    formatAmount(amount) {
      if (!amount || amount === '--') return amount;

      try {
        return parseFloat(amount).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      } catch (e) {
        return amount;
      }
    },

    getPaymentMethodClass(method) {
      if (!method) return 'badge badge-soft-secondary';

      const methodLower = method.toLowerCase();
      if (methodLower.includes('mpesa') || methodLower.includes('m-pesa')) {
        return 'badge badge-soft-success';
      } else if (methodLower.includes('cash')) {
        return 'badge badge-soft-primary';
      } else if (methodLower.includes('bank')) {
        return 'badge badge-soft-info';
      } else if (methodLower.includes('card')) {
        return 'badge badge-soft-warning';
      }

      return 'badge badge-soft-secondary';
    },

    canApprove(item) {
      return item && item.correctionDetails && item.correctionDetails.trim() !== '';
    },

    isProcessingItem(item) {
      return this.isProcessing && this.processingItemId === item.transaction_code;
    },

    isHighlighted(item) {
      return this.highlightedTransactionId === item.transaction_code;
    },

    // Toast notification system
    showToast(message, type = 'info') {
      // In a real implementation, you would use a toast library
      // For this example, we'll just use console.log and alert
      console.log(`[${type.toUpperCase()}]: ${message}`);

      if (type === 'error') {
        // Use alert for errors to ensure visibility
        alert(message);
      }
    }
  }
}
</script>

<style scoped>
/* Highlight animation for rows */
.highlight-row {
  animation: highlight 2s ease-in-out;
}

@keyframes highlight {
  0% { background-color: rgba(255, 243, 205, 0.5); }
  100% { background-color: transparent; }
}

/* Improve table readability */
.table th {
  font-weight: 600;
}

.table td {
  vertical-align: middle;
}

/* Make sure buttons are visible */
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

/* Fix for text alignment */
.text-right {
  text-align: right;
}
</style>